// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/piano/Piano.css */

.piano-board {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 98vw;
  max-width: 400px;
  height: auto;

  /* Темный корпус инструмента */
  background: radial-gradient(circle at center, #2b2b36 0%, #1a1a20 100%);
  border: 4px solid #444;
  border-bottom: 7px solid #333;
  border-radius: 16px;
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.1),
    0 20px 60px rgba(0,0,0,0.9);

  display: flex;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  z-index: 6000;

  user-select: none;
  -webkit-user-select: none;
}

/* --- HEADER --- */
.piano-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  margin-bottom: 15px;
  padding: 10px 15px;
  background: rgba(0,0,0,0.4);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 8px;
  font-family: 'Courier New', monospace;
}

.piano-status {
  font-size: 17px;
  font-weight: 900;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(255,255,255,0.2);
  transition: color 0.3s;
}

.piano-status.listen { color: #fbbf24; }
.piano-status.play { color: #4ade80; }
.piano-status.replay { color: #856fff; }

.piano-score {
  font-size: 15px;
  color: #fbbf24;
  font-weight: bold;
}

/* ИНДИКАТОР ПРОГРЕССА (ТОЧКИ) */
.piano-progress-bar {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
  min-height: 12px;
}

.piano-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #333;
  border: 1px solid #555;
  transition: all 0.2s;
}
.piano-dot.correct { background: #4ade80; border-color: #4ade80; }
.piano-dot.filled-yellow { background: #fbbf24; border-color: #fbbf24; }
.piano-dot.wrong { background: #ef4444; border-color: #ef4444; }
.piano-dot.current { background: #86bbee6f; transform: scale(1.3); }


/* --- КОНТЕЙНЕР КЛАВИАТУРЫ --- */
.piano-keys-container {
  position: relative;
  flex: 1 1;
  display: flex;
  background: #111;
  padding: 4px;
  border-radius: 6px;
  box-shadow: inset 0 5px 15px rgba(0,0,0,0.8);
  min-height: 170px;
  max-height: 300px;
  touch-action: none;
}


/* --- БЕЛАЯ КЛАВИША --- */
.key-white {
  flex: 1 1;
  position: relative;
  z-index: 5; /* Ниже черных */
  margin: 0 2px;
  border-radius: 0 0 5px 5px;

  background: linear-gradient(to bottom, #fff 0%, #f0f0f0 100%);

  /* Глубина уменьшена в 2 раза (было 12px -> стало 6px) */
  box-shadow:
      inset 0 -6px 0 #ccc,
      0 2px 5px rgba(0,0,0,0.2);

  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
  cursor: pointer;

  transition: box-shadow 0.1s ease-out, background-color 0.1s;
  /* Важно: никаких transform, чтобы не было дыр */
  transform: none !important;
}

.key-white:active, .key-white.pressed {
  /* При нажатии тень уменьшается (было 3px -> стало 2px) */
  box-shadow:
      inset 0 -2px 0 #bbb,
      0 0 2px rgba(0,0,0,0.1);

  background: #e0e0e0;
}

.key-label {
  color: #999;
  font-size: 12px;
  font-weight: bold;
  pointer-events: none;
}


/* --- ЧЕРНАЯ КЛАВИША --- */
.key-black {
  position: absolute;
  top: 0;
  width: 8%;
  height: 60%;
  z-index: 20; /* Высокий индекс, чтобы перекрывать белые */

  border-radius: 0 0 4px 4px;

  background: linear-gradient(to bottom, #444 0%, #222 100%);

  /* Добавляем темную границу, чтобы клавиша не сливалась */
  border: 1px solid #111;
  border-top: none;

  /* Глубина уменьшена в 2 раза (было 10px -> стало 5px) */
  box-shadow:
      inset 0 -5px 0 #000,
      2px 4px 6px rgba(0,0,0,0.6); /* Внешняя тень плотнее, чтобы скрыть стыки */

  cursor: pointer;

  transform: translateX(-50%);
  transition: box-shadow 0.1s ease-out;
}

.key-black:active, .key-black.pressed {
  /* При нажатии */
  box-shadow:
      inset 0 -1px 0 #000,
      1px 1px 3px rgba(0,0,0,0.5);

  background: #1a1a1a;

  /* Сохраняем позицию, чтобы не "уезжала" вверх */
  transform: translateX(-50%);
}


/* --- ПОДСВЕТКА НОТ (БЕЛЫЕ) --- */
/* Добавляем ", 0 0 20px ЦВЕТ" в конце box-shadow для свечения */
.key-white[data-note="0"].pressed { background: #ffaaaa; box-shadow: inset 0 -2px 0 #cc8888, 0 0 20px #ffaaaa; }
.key-white[data-note="2"].pressed { background: #ffd8a8; box-shadow: inset 0 -2px 0 #ccaa88, 0 0 20px #ffd8a8; }
.key-white[data-note="4"].pressed { background: #ffec99; box-shadow: inset 0 -2px 0 #ccbb77, 0 0 20px #ffec99; }
.key-white[data-note="5"].pressed { background: #b2f2bb; box-shadow: inset 0 -2px 0 #88cc99, 0 0 20px #b2f2bb; }
.key-white[data-note="7"].pressed { background: #a5d8ff; box-shadow: inset 0 -2px 0 #88aacc, 0 0 20px #a5d8ff; }
.key-white[data-note="9"].pressed { background: #d0bfff; box-shadow: inset 0 -2px 0 #aa99cc, 0 0 20px #d0bfff; }
.key-white[data-note="11"].pressed { background: #fcc2d7; box-shadow: inset 0 -2px 0 #cc99aa, 0 0 20px #fcc2d7; }

/* --- ПОДСВЕТКА НОТ (ЧЕРНЫЕ) --- */
/* То же самое для черных, используем их основной цвет для свечения */
.key-black[data-note="1"].pressed  { background: #e08875; border-color: #e08875; box-shadow: inset 0 -1px 0 #a65f4f, 0 0 15px #e08875; }
.key-black[data-note="3"].pressed  { background: #dbb565; border-color: #dbb565; box-shadow: inset 0 -1px 0 #a38242, 0 0 15px #dbb565; }
.key-black[data-note="6"].pressed  { background: #75c0b0; border-color: #75c0b0; box-shadow: inset 0 -1px 0 #4e8a7c, 0 0 15px #75c0b0; }
.key-black[data-note="8"].pressed  { background: #85aadd; border-color: #85aadd; box-shadow: inset 0 -1px 0 #5a78a3, 0 0 15px #85aadd; }
.key-black[data-note="10"].pressed { background: #cc99d5; border-color: #cc99d5; box-shadow: inset 0 -1px 0 #966b9e, 0 0 15px #cc99d5; }
/* БЛОКИРОВЩИК И АДАПТИВ */
.piano-blocker {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.1);
  z-index: 30;
  cursor: wait;
}

/* Мобильный поворот */
@media (min-width: 600px) {
  .piano-board {
    width: 95vw;
    height: 95vh;
    max-width: 650px;
    max-height: 400px;
    border-top: 2px solid #333;
    border-bottom: 3px solid #333;
  }
  .piano-header {
    padding: 3px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/piano/Piano.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,WAAW;EACX,gBAAgB;EAChB,YAAY;;EAEZ,8BAA8B;EAC9B,uEAAuE;EACvE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB;;+BAE6B;;EAE7B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,aAAa;;EAEb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,uBAAuB,cAAc,EAAE;AACvC,qBAAqB,cAAc,EAAE;AACrC,uBAAuB,cAAc,EAAE;;AAEvC;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;AACA,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE;AACjE,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE;AACvE,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE;AAC/D,qBAAqB,qBAAqB,EAAE,qBAAqB,EAAE;;;AAGnE,iCAAiC;AACjC;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA,0BAA0B;AAC1B;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU,EAAE,gBAAgB;EAC5B,aAAa;EACb,0BAA0B;;EAE1B,6DAA6D;;EAE7D,wDAAwD;EACxD;;+BAE6B;;EAE7B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;EAEf,2DAA2D;EAC3D,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,yDAAyD;EACzD;;6BAE2B;;EAE3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;;AAGA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,WAAW,EAAE,4CAA4C;;EAEzD,0BAA0B;;EAE1B,0DAA0D;;EAE1D,yDAAyD;EACzD,sBAAsB;EACtB,gBAAgB;;EAEhB,wDAAwD;EACxD;;iCAE+B,EAAE,6CAA6C;;EAE9E,eAAe;;EAEf,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB;;iCAE+B;;EAE/B,mBAAmB;;EAEnB,gDAAgD;EAChD,2BAA2B;AAC7B;;;AAGA,kCAAkC;AAClC,gEAAgE;AAChE,oCAAoC,mBAAmB,EAAE,oDAAoD,EAAE;AAC/G,oCAAoC,mBAAmB,EAAE,oDAAoD,EAAE;AAC/G,oCAAoC,mBAAmB,EAAE,oDAAoD,EAAE;AAC/G,oCAAoC,mBAAmB,EAAE,oDAAoD,EAAE;AAC/G,oCAAoC,mBAAmB,EAAE,oDAAoD,EAAE;AAC/G,oCAAoC,mBAAmB,EAAE,oDAAoD,EAAE;AAC/G,qCAAqC,mBAAmB,EAAE,oDAAoD,EAAE;;AAEhH,mCAAmC;AACnC,qEAAqE;AACrE,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE,oDAAoD,EAAE;AACvI,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE,oDAAoD,EAAE;AACvI,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE,oDAAoD,EAAE;AACvI,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE,oDAAoD,EAAE;AACvI,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE,oDAAoD,EAAE;AACvI,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* games/piano/Piano.css */\n\n.piano-board {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  width: 98vw;\n  max-width: 400px;\n  height: auto;\n\n  /* Темный корпус инструмента */\n  background: radial-gradient(circle at center, #2b2b36 0%, #1a1a20 100%);\n  border: 4px solid #444;\n  border-bottom: 7px solid #333;\n  border-radius: 16px;\n  box-shadow:\n    inset 0 1px 0 rgba(255,255,255,0.1),\n    0 20px 60px rgba(0,0,0,0.9);\n\n  display: flex;\n  flex-direction: column;\n  padding: 5px;\n  box-sizing: border-box;\n  z-index: 6000;\n\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n/* --- HEADER --- */\n.piano-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 5px;\n  margin-bottom: 15px;\n  padding: 10px 15px;\n  background: rgba(0,0,0,0.4);\n  border: 1px solid rgba(255,255,255,0.05);\n  border-radius: 8px;\n  font-family: 'Courier New', monospace;\n}\n\n.piano-status {\n  font-size: 17px;\n  font-weight: 900;\n  color: #fff;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  text-shadow: 0 0 10px rgba(255,255,255,0.2);\n  transition: color 0.3s;\n}\n\n.piano-status.listen { color: #fbbf24; }\n.piano-status.play { color: #4ade80; }\n.piano-status.replay { color: #856fff; }\n\n.piano-score {\n  font-size: 15px;\n  color: #fbbf24;\n  font-weight: bold;\n}\n\n/* ИНДИКАТОР ПРОГРЕССА (ТОЧКИ) */\n.piano-progress-bar {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  min-height: 12px;\n}\n\n.piano-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: #333;\n  border: 1px solid #555;\n  transition: all 0.2s;\n}\n.piano-dot.correct { background: #4ade80; border-color: #4ade80; }\n.piano-dot.filled-yellow { background: #fbbf24; border-color: #fbbf24; }\n.piano-dot.wrong { background: #ef4444; border-color: #ef4444; }\n.piano-dot.current { background: #86bbee6f; transform: scale(1.3); }\n\n\n/* --- КОНТЕЙНЕР КЛАВИАТУРЫ --- */\n.piano-keys-container {\n  position: relative;\n  flex: 1;\n  display: flex;\n  background: #111;\n  padding: 4px;\n  border-radius: 6px;\n  box-shadow: inset 0 5px 15px rgba(0,0,0,0.8);\n  min-height: 170px;\n  max-height: 300px;\n  touch-action: none;\n}\n\n\n/* --- БЕЛАЯ КЛАВИША --- */\n.key-white {\n  flex: 1;\n  position: relative;\n  z-index: 5; /* Ниже черных */\n  margin: 0 2px;\n  border-radius: 0 0 5px 5px;\n\n  background: linear-gradient(to bottom, #fff 0%, #f0f0f0 100%);\n\n  /* Глубина уменьшена в 2 раза (было 12px -> стало 6px) */\n  box-shadow:\n      inset 0 -6px 0 #ccc,\n      0 2px 5px rgba(0,0,0,0.2);\n\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding-bottom: 8px;\n  cursor: pointer;\n\n  transition: box-shadow 0.1s ease-out, background-color 0.1s;\n  /* Важно: никаких transform, чтобы не было дыр */\n  transform: none !important;\n}\n\n.key-white:active, .key-white.pressed {\n  /* При нажатии тень уменьшается (было 3px -> стало 2px) */\n  box-shadow:\n      inset 0 -2px 0 #bbb,\n      0 0 2px rgba(0,0,0,0.1);\n\n  background: #e0e0e0;\n}\n\n.key-label {\n  color: #999;\n  font-size: 12px;\n  font-weight: bold;\n  pointer-events: none;\n}\n\n\n/* --- ЧЕРНАЯ КЛАВИША --- */\n.key-black {\n  position: absolute;\n  top: 0;\n  width: 8%;\n  height: 60%;\n  z-index: 20; /* Высокий индекс, чтобы перекрывать белые */\n\n  border-radius: 0 0 4px 4px;\n\n  background: linear-gradient(to bottom, #444 0%, #222 100%);\n\n  /* Добавляем темную границу, чтобы клавиша не сливалась */\n  border: 1px solid #111;\n  border-top: none;\n\n  /* Глубина уменьшена в 2 раза (было 10px -> стало 5px) */\n  box-shadow:\n      inset 0 -5px 0 #000,\n      2px 4px 6px rgba(0,0,0,0.6); /* Внешняя тень плотнее, чтобы скрыть стыки */\n\n  cursor: pointer;\n\n  transform: translateX(-50%);\n  transition: box-shadow 0.1s ease-out;\n}\n\n.key-black:active, .key-black.pressed {\n  /* При нажатии */\n  box-shadow:\n      inset 0 -1px 0 #000,\n      1px 1px 3px rgba(0,0,0,0.5);\n\n  background: #1a1a1a;\n\n  /* Сохраняем позицию, чтобы не \"уезжала\" вверх */\n  transform: translateX(-50%);\n}\n\n\n/* --- ПОДСВЕТКА НОТ (БЕЛЫЕ) --- */\n/* Добавляем \", 0 0 20px ЦВЕТ\" в конце box-shadow для свечения */\n.key-white[data-note=\"0\"].pressed { background: #ffaaaa; box-shadow: inset 0 -2px 0 #cc8888, 0 0 20px #ffaaaa; }\n.key-white[data-note=\"2\"].pressed { background: #ffd8a8; box-shadow: inset 0 -2px 0 #ccaa88, 0 0 20px #ffd8a8; }\n.key-white[data-note=\"4\"].pressed { background: #ffec99; box-shadow: inset 0 -2px 0 #ccbb77, 0 0 20px #ffec99; }\n.key-white[data-note=\"5\"].pressed { background: #b2f2bb; box-shadow: inset 0 -2px 0 #88cc99, 0 0 20px #b2f2bb; }\n.key-white[data-note=\"7\"].pressed { background: #a5d8ff; box-shadow: inset 0 -2px 0 #88aacc, 0 0 20px #a5d8ff; }\n.key-white[data-note=\"9\"].pressed { background: #d0bfff; box-shadow: inset 0 -2px 0 #aa99cc, 0 0 20px #d0bfff; }\n.key-white[data-note=\"11\"].pressed { background: #fcc2d7; box-shadow: inset 0 -2px 0 #cc99aa, 0 0 20px #fcc2d7; }\n\n/* --- ПОДСВЕТКА НОТ (ЧЕРНЫЕ) --- */\n/* То же самое для черных, используем их основной цвет для свечения */\n.key-black[data-note=\"1\"].pressed  { background: #e08875; border-color: #e08875; box-shadow: inset 0 -1px 0 #a65f4f, 0 0 15px #e08875; }\n.key-black[data-note=\"3\"].pressed  { background: #dbb565; border-color: #dbb565; box-shadow: inset 0 -1px 0 #a38242, 0 0 15px #dbb565; }\n.key-black[data-note=\"6\"].pressed  { background: #75c0b0; border-color: #75c0b0; box-shadow: inset 0 -1px 0 #4e8a7c, 0 0 15px #75c0b0; }\n.key-black[data-note=\"8\"].pressed  { background: #85aadd; border-color: #85aadd; box-shadow: inset 0 -1px 0 #5a78a3, 0 0 15px #85aadd; }\n.key-black[data-note=\"10\"].pressed { background: #cc99d5; border-color: #cc99d5; box-shadow: inset 0 -1px 0 #966b9e, 0 0 15px #cc99d5; }\n/* БЛОКИРОВЩИК И АДАПТИВ */\n.piano-blocker {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.1);\n  z-index: 30;\n  cursor: wait;\n}\n\n/* Мобильный поворот */\n@media (min-width: 600px) {\n  .piano-board {\n    width: 95vw;\n    height: 95vh;\n    max-width: 650px;\n    max-height: 400px;\n    border-top: 2px solid #333;\n    border-bottom: 3px solid #333;\n  }\n  .piano-header {\n    padding: 3px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
